import * as bootstrap from "bootstrap";

export function showModal(element){
    const modal = new bootstrap.Modal(element, {
        keyboard: false,
        backdrop: 'static'
    });
    modal.show();
    return modal;
}